/* Pulled live from the Shopify Admin API on 2026-08-15: every active product, its real
   option names, variant IDs, images, prices and copy. Do not hand-edit; re-run
   build_data.py against a fresh pull instead. */
var GH_DATA = {
 "cdn": "https://cdn.shopify.com/s/files/1/1038/9880/8401/files/",
 "products": [
  {
   "title": "Honduras",
   "handle": "honduras",
   "roast": "Medium",
   "color": "#487DB2",
   "notes": [
    "Sweet & Tart",
    "Nutty",
    "Berry"
   ],
   "best": true,
   "variants": [
    {
     "id": "59489850949713",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489850884177",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489850818641",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489850916945",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489850851409",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489850982481",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "Sourced directly from the Hacia el Futuro cooperative in Zapote, Honduras. We've visited the farm, met the farmers, and pay above premium prices, because we know exactly what this coffee is worth. Roasted medium in small batches in Belmond, Iowa. Sweet and fruit-forward with soft berry, mild nuttiness, and a bright finish that makes it easy to drink but interesting enough to slow down and actually taste.\nFresh crop offer: use code FRESHCROP20 at checkout for 20% off Honduras. One use per customer, and it does not combine with other codes.",
   "tastingNotes": "Expect a sweet and tart cup with a soft berry tone, mild nuttiness, and a bright citrus-like acidity that keeps things lively. Mellow sweetness rounds everything out for a clean, balanced finish. One of those coffees that's easy to drink but interesting enough to slow down and actually taste.",
   "originStory": "We've been to this farm. We've met the farmers, shaken their hands, and seen firsthand what direct trade actually looks like on the ground.\nOur Honduras comes from the Hacia el Futuro cooperative in Zapote, Honduras, a community of small family farms that have been growing specialty arabica for generations. In 2021, the cooperative built their own washing station, giving farmers control over processing their own coffee for the first time. That's what real progress looks like.\nWe pay above premium price for every pound we bring in. Not because we have to, but because we've looked these farmers in the eye and we know what their work is worth. No middlemen. No brokers. Just a direct relationship built on respect and a shared commitment to exceptional coffee.\nWhen you buy this bag, more of your money reaches the people who grew it than almost anywhere else you could buy coffee.",
   "elevation": "1200-1700 MASL (meters above sea level)",
   "harvest": "December-March",
   "grind": "Honduras coffee is picked ripe and depulped the same day, then fermented for 12-24 hours in open-air tanks. It is then washed clean and spread on patios or raised beds to dry, a process that takes around 15 days. This careful washed method is what gives our Honduras its clean, bright character and well-defined flavors.",
   "rating": "5.0",
   "ratingCount": "4",
   "images": [
    {
     "src": "honduras_product_photo.png?v=1778911228",
     "alt": "Honduras single-origin coffee bag from The Golden Hopper"
    },
    {
     "src": "Honduras_flavor_notes.png?v=1778911228",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Honduras_FTO-3-2022-05-03-032340.jpg?v=1779898957",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Honduras_Cafescor-1-2021-12-17-195220.jpg?v=1779900226",
     "alt": ""
    },
    {
     "src": "group_photo.png?v=1779252234",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee"
  },
  {
   "title": "Ethiopia Yirgacheffe",
   "handle": "ethiopia-yirgacheffe",
   "roast": "Medium",
   "color": "#FAA84A",
   "notes": [
    "Jasmine",
    "Citrus",
    "Honey"
   ],
   "best": true,
   "variants": [
    {
     "id": "59489849213009",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849278545",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849311313",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849245777",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849344081",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489849180241",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "Ethiopia is the birthplace of Arabica coffee, not as an introduced crop but as a plant that has grown wild and been part of everyday life for centuries. We source from Yirgacheffe, where smallholder farmers tend small shade-grown plots that function more like coffee gardens than traditional farms. Roasted medium in small batches in Belmond, Iowa. Delicate and aromatic with bright floral notes, lively citrus, and a natural honey sweetness that lingers. As close to the source of coffee as it gets.",
   "tastingNotes": "A delicate, aromatic cup with bright floral notes, lively citrus acidity, and a natural honey sweetness that lingers through the finish. Light bodied and clean with a complexity that rewards slow sipping. One of the most distinctive and celebrated coffees in the world, for good reason.",
   "originStory": "Ethiopia is the birthplace of Arabica coffee. Not as a cash crop introduced through colonization, but as a plant that has been growing wild, cultivated, and consumed as part of everyday life for centuries. We source from the Yirgacheffe region, a lush highland area known for producing some of the most complex and aromatic coffees in the world. Most coffee here is shade-grown by smallholder farmers on tiny plots that function more like coffee gardens than traditional farms. The multitude of microregions within Yirgacheffe creates endlessly complex profiles depending on the specific washing station, altitude, and growing conditions. Ethiopia is where coffee began, and tasting it here is as close to the source as it gets.",
   "elevation": "1900-2400 MASL (meters above sea level)",
   "harvest": "October-January",
   "grind": "Ethiopian washed coffees are picked ripe and depulped the same day, then fermented in open-air tanks for 8-12 hours before being washed clean through water channels to remove the mucilage. The coffee seeds are then spread on raised beds to dry for 5-15 days depending on the weather. This careful process is what gives our Ethiopia its remarkable clarity and floral brightness.",
   "rating": "5.0",
   "ratingCount": "6",
   "images": [
    {
     "src": "ethiopia_product_photo.png?v=1778915524",
     "alt": "Ethiopia Yirgacheffe single-origin coffee bag from The Golden Hopper"
    },
    {
     "src": "ethiopia_flavor_notes.png?v=1778915525",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Ethiopia_Heirlooms-2022-08-02-025913.jpg?v=1779905004",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Ethiopia_Yirgacheffe-2022-01-28-151719.jpg?v=1779905004",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_GEthiopia_DP-2022-05-10-130635_1.jpg?v=1779905024",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee"
  },
  {
   "title": "Espresso Blend",
   "handle": "espresso-blend-copy",
   "roast": "Medium",
   "color": "#946326",
   "notes": [
    "Chocolate",
    "Caramel",
    "Nutty"
   ],
   "best": true,
   "variants": [
    {
     "id": "59580208119889",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59580208152657",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59580208185425",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59580208218193",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59580208250961",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59580208283729",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "A blend of four single origins, Brazil, Honduras, Mexico, and Ethiopia. Each chosen for the role it plays in the cup. Roasted medium in small batches in Belmond, Iowa. Rich chocolate, smooth caramel, and a subtle brightness that works beautifully as espresso, drip, or anything in between.",
   "tastingNotes": "Milk chocolate and roasted nut form the base, with warm caramel sweetness and a soft brightness that keeps everything balanced. Rich and smooth with enough depth to enjoy any way you brew it.",
   "originStory": "This blend was built around espresso flavor without being limited to one brew method. Brazil brings the body, Honduras brings the sweetness, Mexico adds smoothness, and Ethiopia lifts everything with a subtle brightness. Four origins working as one.",
   "elevation": "Brazil: 750-1100MASL (meters above sea level)\nHonduras: 1200-1700 MASL (meters above sea level)\nMexico: 1000-1800 MASL (meters above sea level)\nEthiopia: 1900-2400 MASL (meters above sea level)",
   "harvest": "Year-round blend, sourced from multiple harvest cycles across four origins",
   "grind": "A blend of washed and natural processed coffees. The natural processed Brazil adds body and sweetness while the washed Honduras, Mexico, and Ethiopia contribute clarity and balance.",
   "rating": "5.0",
   "ratingCount": "11",
   "images": [
    {
     "src": "espresso_product_photo.png?v=1778915384",
     "alt": "Espresso Blend coffee bag from The Golden Hopper"
    },
    {
     "src": "espresso_flavor_notes.png?v=1778915394",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Brazil_Serra_Negra-4-2022-04-26-124330.jpg?v=1779898955",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Honduras_FTO-3-2022-05-03-032340.jpg?v=1779898957",
     "alt": ""
    },
    {
     "src": "CLOSE_UP_ROAST_PNG_dc000c40-297c-470c-b352-98da04e03ebd.png?v=1780029026",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee",
   "video": {
    "id": "260e967cef294063a7b35de603c5313f",
    "r": "HD-720p-3.0Mbps-91737328",
    "poster": "preview_images/260e967cef294063a7b35de603c5313f.thumbnail.0000000000.jpg?v=1786888779",
    "alt": "How naturally processed coffee is harvested and dried",
    "under": "Processing Method",
    "cap": "Watch how this coffee is dried"
   }
  },
  {
   "title": "Colombia",
   "handle": "colombia",
   "roast": "Medium",
   "color": "#E696FA",
   "notes": [
    "Toffee",
    "Peach",
    "Caramel"
   ],
   "best": false,
   "variants": [
    {
     "id": "59489850327121",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489850163281",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489850196049",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489850228817",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489850294353",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489850261585",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "We source Excelso grade Colombian coffee from smallholder farmers across the country's major growing regions, selected through direct farm relationships and cupped and approved before it ever reaches us. Roasted medium in small batches in Belmond, Iowa. Bright citrus, rich caramel, and a warm toffee depth that lingers. Clean, versatile, and consistently one of the smoothest cups we offer.",
   "tastingNotes": "A smooth, well-rounded cup with bright citrus acidity, rich caramel sweetness, and a warm toffee depth that lingers. Mellow fruit-like sweetness rounds everything out for a clean, satisfying finish. Incredibly versatile.",
   "originStory": "Colombia is one of the most celebrated coffee origins in the world and one of the only countries where coffee is harvested year-round thanks to its diverse microclimates and geography. We source Excelso grade coffee, meaning screen size 15 and above, sourced from smallholder farmers across Colombia's major growing regions. Colombian sourcing is built on long-standing relationships with producers, with green buyers visiting farms multiple times a year to cup and approve lots before they ever reach us. The result is a consistently clean, traceable cup that represents the best of what Colombian coffee can offer.",
   "elevation": "1400-2000 MASL (meters above sea level)",
   "harvest": "Year-Round",
   "grind": "Colombia is best known for its washed coffees. After picking, cherries are depulped the same day and fermented in open-air tanks for 12-36 hours before being washed clean and dried on patios, parabolic dryers, or solar driers. This meticulous process is what gives our Colombia its clean clarity, bright acidity, and well-defined sweetness.",
   "rating": "5.0",
   "ratingCount": "1",
   "images": [
    {
     "src": "columbia_bag_blank_copy.png?v=1781235959",
     "alt": "Colombia single-origin coffee bag from The Golden Hopper"
    },
    {
     "src": "columbia_Props_copy.png?v=1781235959",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Colombia-2021-12-14-215331.jpg?v=1779902164",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Colombia-1-2021-12-17-150013.jpg?v=1779902164",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Colombia_DP-2022-05-10-125647.jpg?v=1779902164",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee",
   "video": {
    "id": "04fc487af3ce4bcdac8d29d76e70f841",
    "r": "HD-720p-3.0Mbps-91737325",
    "poster": "preview_images/04fc487af3ce4bcdac8d29d76e70f841.thumbnail.0000000000.jpg?v=1786888844",
    "alt": "Sourcing our Colombia coffee",
    "under": "Origin Story",
    "cap": "Watch where this coffee comes from"
   }
  },
  {
   "title": "Guatemala",
   "handle": "guatemala",
   "roast": "Medium",
   "color": "#78F0BE",
   "notes": [
    "Sweet Citrus",
    "Melon",
    "Caramel"
   ],
   "best": false,
   "variants": [
    {
     "id": "59489849737297",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849704529",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849573457",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849671761",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849638993",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489849606225",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "Grown at extreme altitudes in one of the highest coffee regions in the country, where indigenous farming families tend small parcels deeply connected to their land and traditions. Roasted medium in small batches in Belmond, Iowa. Bright citrus, soft melon fruitiness, and warm caramel sweetness that ties it all together for a cup that is complex enough to explore slowly but approachable enough for every morning.",
   "tastingNotes": "A bright, lively cup with sweet citrus acidity, a soft melon-like fruitiness, and a warm caramel sweetness that ties everything together. Good acidity with a mellow, sweet finish. Complex enough to explore slowly but approachable enough for every morning.",
   "originStory": "Huehuetenango sits in western Guatemala bordering Mexico and is widely considered one of the finest coffee regions in all of Latin America. At elevations reaching up to 2,200 meters, it is one of the highest growing areas in the country. Hot dry winds from Mexico protect the region from frost, allowing coffee to thrive at these extreme altitudes. The indigenous population plays a central role in coffee production here, with most farmers working small family parcels deeply connected to the land and their cultural traditions. The result is a fruit-forward, complex cup that reflects the unique character of this remarkable high-altitude region.",
   "elevation": "1400-2200 MASL (meters above sea level)",
   "harvest": "December-May",
   "grind": "After harvesting, cherries are picked ripe and depulped the same or following day, then allowed to ferment for 12-48 hours depending on the climate. The coffee is then washed clean of mucilage and spread on patios or raised beds to dry. Guatemala's diverse terroir means each producer brings slight variations to this process, contributing to the complexity in the cup.",
   "rating": "5.0",
   "ratingCount": "6",
   "images": [
    {
     "src": "guatemala_product_photo.png?v=1778915485",
     "alt": "Guatemala single-origin coffee bag from The Golden Hopper"
    },
    {
     "src": "guatemala_flavor_notes.png?v=1778915485",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Guatemala_DP-2022-05-10-130751.jpg?v=1779904015",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Guatemala-4-2021-12-17-194621.jpg?v=1779904015",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Guatemala_Def-2022-08-02-030915.jpg?v=1779904015",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee",
   "video": {
    "id": "0b94bd8f2ed3414392e50ee9d146f5ca",
    "r": "HD-720p-3.0Mbps-91737326",
    "poster": "preview_images/0b94bd8f2ed3414392e50ee9d146f5ca.thumbnail.0000000000.jpg?v=1786888806",
    "alt": "Sourcing our Guatemala coffee",
    "under": "Origin Story",
    "cap": "Watch where this coffee comes from"
   }
  },
  {
   "title": "Brazil",
   "handle": "brazil",
   "roast": "Dark",
   "color": "#2C7A34",
   "notes": [
    "Chocolate",
    "Nutty",
    "Caramel"
   ],
   "best": false,
   "variants": [
    {
     "id": "59489852850257",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489852948561",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489852883025",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489852915793",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489852784721",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489852817489",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "One of the most approachable coffees in the world, smooth, low-acid, and naturally sweet. Roasted dark in small batches in Belmond, Iowa, this cup delivers milk chocolate richness and caramel sweetness that's easy to drink every day.",
   "tastingNotes": "Expect a smooth, approachable cup with mild cocoa, rich caramel sweetness, and a deep nuttiness that lingers. The body is heavy and satisfying with just enough lemon-like acidity to keep things balanced without ever feeling sharp or bright. Easy to drink every day and impossible to get tired of.",
   "originStory": "Brazil is one of the world's oldest and most storied coffee origins, with coffee dating back to the early 1700s. We source from the Carmo de Minas region of Minas Gerais. Home to the Serra Negra program, one of the most classic Brazilian profiles available. \nBrazil produces more coffee than any other country in the world, accounting for roughly a third of global supply. Yet only a small fraction of that reaches specialty grade. That is exactly what we source.",
   "elevation": "750-1100MASL (meters above sea level)",
   "harvest": "May-August",
   "grind": "Brazilian cherries are picked and then dried whole before hulling. No washing, no pulping. This traditional method allows the fruit's natural sugars to absorb into the bean during drying, which is what gives this coffee its signature nutty creaminess and smooth, tempered fruit tones.",
   "rating": "5.0",
   "ratingCount": "1",
   "images": [
    {
     "src": "brazil_bag_blank_copy.png?v=1781333309",
     "alt": "Brazil single-origin coffee bag from The Golden Hopper"
    },
    {
     "src": "Brazil_Props_copy.png?v=1781333309",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Brazil_Serra_Negra-2-2022-04-26-124330_1.jpg?v=1779898956",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Brazil_Serra_Negra-3-2022-04-26-124330_1.jpg?v=1779898955",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Brazil_Serra_Negra-4-2022-04-26-124330.jpg?v=1779898955",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee",
   "video": {
    "id": "544a33a0dd3c472785e82f2c65af9395",
    "r": "HD-720p-2.1Mbps-91737287",
    "poster": "preview_images/544a33a0dd3c472785e82f2c65af9395.thumbnail.0000000000.jpg?v=1786888574",
    "alt": "Sourcing our Brazil coffee",
    "under": "Origin Story",
    "cap": "Watch where this coffee comes from"
   }
  },
  {
   "title": "Mexico",
   "handle": "mexico",
   "roast": "Medium",
   "color": "#C03030",
   "notes": [
    "Cocoa",
    "Cedar",
    "Apricot"
   ],
   "best": false,
   "variants": [
    {
     "id": "59489852588113",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489852522577",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489852424273",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489852555345",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489852457041",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489852489809",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "Grown in the high-elevation regions of Chiapas and Oaxaca, this coffee develops slowly under shade trees for deeper, more layered flavor. Roasted medium in small batches in Belmond, Iowa. Expect to taste gentle cocoa, toasted almond, and a soft brightness that makes it an easy everyday cup.",
   "tastingNotes": "A clean, approachable cup with rich cocoa depth, a sweet cedar warmth, and a soft apricot fruitiness that lingers. Tangy acidity keeps things lively while a mellow sweetness rounds everything out. Easy drinking but layered enough to reward a slow morning.",
   "originStory": "Mexico has a long and complex coffee history, but in recent decades small indigenous farming cooperatives have transformed its reputation into one built on sustainability, quality, and authenticity. The Cristal program draws from multiple growing regions including Veracruz, Oaxaca, and Chiapas, areas known for high altitude growing conditions and deep organic farming traditions. Many of these farms sit within buffer zones near El Triunfo Biosphere Reserve, one of the largest forest reserves in the world. We source this as part of our commitment to traceable, specialty-grade coffee grown by people who genuinely care about the land.",
   "elevation": "1000-1800 MASL (meters above sea level)",
   "harvest": "November-March",
   "grind": "After harvesting, Mexico Cristal is depulped the same day then fermented for 12-18 hours before being washed clean of mucilage and dried on patios or in mechanical dryers. This careful washed process is what gives this coffee its clean, well-defined character and bright tangy acidity.",
   "rating": "5.0",
   "ratingCount": "1",
   "images": [
    {
     "src": "mexico_product_photo.png?v=1778909742",
     "alt": "Mexico single-origin coffee bag from The Golden Hopper"
    },
    {
     "src": "mexico_flavor_notes.png?v=1778909742",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Mexico_Cristal-2-2022-04-26-124234.jpg?v=1779897831",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Mexico_Cristal-3-2022-04-26-124234.jpg?v=1779897832",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee",
   "video": {
    "id": "b02f0b7f15fe433aaca52be7809fda38",
    "r": "HD-720p-3.0Mbps-91737324",
    "poster": "preview_images/b02f0b7f15fe433aaca52be7809fda38.thumbnail.0000000000.jpg?v=1786888796",
    "alt": "Sourcing our Mexico coffee",
    "under": "Origin Story",
    "cap": "Watch where this coffee comes from"
   }
  },
  {
   "title": "Tanzania Peaberry Plus",
   "handle": "tanzania-peaberry-plus",
   "roast": "Medium",
   "color": "#8B3A52",
   "notes": [
    "Black Cherry",
    "Toffee",
    "Peach"
   ],
   "best": false,
   "variants": [
    {
     "id": "59489849507921",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849475153",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849540689",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849409617",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849376849",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489849442385",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "A peaberry is a naturally occurring mutation where only one seed develops inside the coffee cherry instead of the usual two, occurring in roughly 5 to 12% of any harvest. Denser and more concentrated than a regular bean, Tanzania sorts these lots specifically and is internationally known for them. Roasted medium in small batches in Belmond, Iowa. Deep blackcurrant richness, a wine-like depth, and a bright peachy sweetness that makes it one of the most distinctive and conversation-worthy coffees we carry.",
   "tastingNotes": "A bold, complex cup with deep blackcurrant richness, a wine-like depth, and a bright peachy sweetness that lifts everything up. Balanced acidity with a mellow fruit-like sweetness through the finish. One of the most distinctive and conversation-worthy coffees we carry.",
   "originStory": "Tanzania Peaberry is one of the most unique coffees in the world, and the story starts with the bean itself. A peaberry is a naturally occurring mutation where only one seed develops inside the coffee cherry instead of the usual two. This happens in roughly 5-12% of any harvest. Because peaberries are rounder and denser than regular flat beans, many believe they develop more concentrated flavor during roasting. Tanzania is internationally famous for these peaberry lots, and they are sorted specifically from the rest of the harvest to maintain size uniformity. Most Tanzanian coffee is grown by smallholder farmers with deep generational ties to the land, and Tanzania's proximity to Ethiopia means coffee has been part of the culture here long before it became a commercial crop.",
   "elevation": "1200-1900 MASL (meters above sea level)",
   "harvest": "May-September (South) / July-November (North)",
   "grind": "Tanzania Peaberry is fully washed. Cherries are depulped the same day they're harvested, then fermented in cement tanks for 24-72 hours. They are then washed clean through water channels and spread on raised beds to dry. Sometimes given an additional 8-12 hour post-washing soak before drying. This thorough process produces the clean, complex cup Tanzania peaberries are known for.",
   "rating": null,
   "ratingCount": null,
   "images": [
    {
     "src": "tanzania_product_photo.png?v=1778915554",
     "alt": "Tanzania Peaberry single-origin coffee bag from The Golden Hopper"
    },
    {
     "src": "tanzania_flavor_notes.png?v=1778915555",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Tanzania_DP-2022-05-10-132514.jpg?v=1779905170",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Tanzania_Nglia_Estate-3-2021-12-09-133640.jpg?v=1779905169",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Tanzania_Nglia_Estate-6-2021-12-09-133640.jpg?v=1779905170",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee"
  },
  {
   "title": "Half-Caffeine",
   "handle": "half-caffeine",
   "roast": "Dark",
   "color": "#FADCAA",
   "notes": [
    "Rich Cocoa",
    "Nutty",
    "Honey"
   ],
   "best": false,
   "variants": [
    {
     "id": "59489849901137",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849770065",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489849835601",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849802833",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489849933905",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489849868369",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "Half the caffeine, none of the compromise. A blend of our Espresso and Colombia Decaf, roasted dark in small batches in Belmond, Iowa. Smooth chocolate, bright citrus, and a clean finish that drinks like a full cup without the full kick.",
   "tastingNotes": "Milk chocolate and a bright citrus note up front, with a peanut-like nuttiness that rounds everything out into a smooth, satisfying finish. Easy drinking and balanced at any time of day.",
   "originStory": "Built for people who love coffee but want to dial back the caffeine without giving up the experience. Our Espresso Blend brings together Brazil, Honduras, Mexico, and Ethiopia. Each chosen for the body, sweetness, smoothness, and brightness they contribute to the cup. Our Colombia Decaf from the Huila region rounds it out, decaffeinated using the Ethyl Acetate process to preserve every bit of flavor other decaf methods lose. Half the caffeine, twice the thought behind it.",
   "elevation": "Brazil: 750-1100MASL (meters above sea level)\nHonduras: 1200-1700 MASL (meters above sea level)\nMexico: 1000-1800 MASL (meters above sea level)\nEthiopia: 1900-2400 MASL (meters above sea level)\nDecaf Colombia: 1400-2000 MASL (meters above sea level)",
   "harvest": "Year-round blend sourced from multiple harvest cycles",
   "grind": "A blend of naturally and washed processed coffees combined with an Ethyl Acetate decaffeinated Colombia. EA is a naturally derived process that removes caffeine while preserving the flavor other decaf methods strip away.",
   "rating": "5.0",
   "ratingCount": "1",
   "images": [
    {
     "src": "halfcaffeine_product_photo.png?v=1778917976",
     "alt": "Half-Caffeine coffee bag from The Golden Hopper"
    },
    {
     "src": "halfcaffeine_flavor_notes.png?v=1778917975",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee",
   "video": {
    "id": "bcd0137fde9b49838523a278d1336bfe",
    "r": "HD-720p-3.0Mbps-91737327",
    "poster": "preview_images/bcd0137fde9b49838523a278d1336bfe.thumbnail.0000000000.jpg?v=1786888784",
    "alt": "How naturally processed coffee is harvested and dried",
    "under": "Processing Method",
    "cap": "Watch how this coffee is dried"
   }
  },
  {
   "title": "Decaf",
   "handle": "decaf",
   "roast": "Medium",
   "color": "#6A6A6A",
   "notes": [
    "Brown Sugar",
    "Apricot",
    "Sweet Cream"
   ],
   "best": false,
   "variants": [
    {
     "id": "59489848623185",
     "opts": {
      "Size": "12oz",
      "Grind": "Ground"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489848688721",
     "opts": {
      "Size": "12oz",
      "Grind": "Whole Bean"
     },
     "price": 19.0,
     "available": true
    },
    {
     "id": "59489848655953",
     "opts": {
      "Size": "2lb",
      "Grind": "Ground"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489848590417",
     "opts": {
      "Size": "2lb",
      "Grind": "Whole Bean"
     },
     "price": 43.0,
     "available": true
    },
    {
     "id": "59489848754257",
     "opts": {
      "Size": "5lb",
      "Grind": "Ground"
     },
     "price": 80.0,
     "available": true
    },
    {
     "id": "59489848721489",
     "opts": {
      "Size": "5lb",
      "Grind": "Whole Bean"
     },
     "price": 80.0,
     "available": true
    }
   ],
   "description": "Sourced from small family farms in the Huila region of Colombia, where elevation and geography create some of the most complex growing conditions in the country. Decaffeinated using the Ethyl Acetate process, a naturally derived and gentler method that preserves the flavor other decaf processes strip away. Roasted medium in small batches in Belmond, Iowa. Warm malt, brown sugar depth, and a crisp brightness that proves decaf does not have to be boring.",
   "tastingNotes": "A surprisingly complex decaf with warm malt sweetness, crisp red apple brightness, and a rich brown sugar depth that lingers. Mellow candy-like sweetness with just enough tart citrus acidity to keep things lively. Proof that decaf doesn't have to be boring.",
   "originStory": "This decaf comes from the Huila region of southwestern Colombia, nestled between the Central and Eastern ranges of the Andes mountains. Huila accounts for nearly 20% of Colombia's total coffee production, yet 80% of its producers operate on less than three hectares of land, small family farms where quality is deeply personal. The variation in elevation across the Magdalena Valley creates some of the most complex and unique growing conditions in the country. We chose an Ethyl Acetate decaf process specifically because EA is a naturally derived compound, making it one of the gentler and more flavor-preserving decaffeination methods available.",
   "elevation": "1400-2000 MASL (meters above sea level)",
   "harvest": "Main Crop: October-December / Fly Crop: June-August",
   "grind": "After harvest, this coffee goes through a full washed process. Picked ripe, depulped the same day, fermented in open-air tanks for 12-36 hours, then washed clean and dried. It is then decaffeinated using Ethyl Acetate, a naturally occurring compound found in fermented sugars and fruits like bananas. The green coffee is steamed to open the pores, soaked in an EA solution that bonds with and removes the caffeine, then steamed again to remove any remaining traces. The result is a clean, naturally decaffeinated coffee that keeps the flavor intact.",
   "rating": "5.0",
   "ratingCount": "1",
   "images": [
    {
     "src": "decaf_bag_blank_copy.png?v=1781337101",
     "alt": "Decaf Colombia coffee bag from The Golden Hopper"
    },
    {
     "src": "decaf_Props_copy.png?v=1781337102",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Colombia-2021-12-14-215331_1.jpg?v=1779905817",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Colombia_DP-2022-05-10-125647_33b35e32-56ad-4c2d-b798-d0ce63fefb6d.jpg?v=1779905817",
     "alt": ""
    },
    {
     "src": "Cafe_Imports_Colombia-1-2021-12-17-150013_d7acfe50-06ad-4a58-a14a-1687b5abae6e.jpg?v=1779905817",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "12oz",
      "2lb",
      "5lb"
     ]
    },
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": "coffee"
  },
  {
   "title": "The Trio",
   "handle": "coffee-trio-honduras-ethiopia-espresso",
   "roast": "Medium",
   "color": "#C87A2B",
   "notes": [
    "Berry & Nutty",
    "Jasmine & Citrus",
    "Chocolate & Caramel"
   ],
   "best": false,
   "variants": [
    {
     "id": "59950469808209",
     "opts": {
      "Grind": "Ground"
     },
     "price": 42.0,
     "available": true
    },
    {
     "id": "59950469840977",
     "opts": {
      "Grind": "Whole Bean"
     },
     "price": 42.0,
     "available": true
    }
   ],
   "description": "Three 12oz bags, roasted in small batches in Belmond, Iowa, and shipped free.\nHonduras. Sourced directly from the Hacia el Futuro cooperative in Zapote, Honduras. We've visited the farm, met the farmers, and pay above premium prices, because we know exactly what this coffee is worth. Sweet and fruit-forward with soft berry, mild nuttiness, and a bright finish.\nEthiopia Yirgacheffe. From the birthplace of Arabica, where smallholder farmers tend shade-grown plots that function more like coffee gardens than farms. Delicate and aromatic with bright floral notes, lively citrus, and a natural honey sweetness that lingers.\nEspresso Blend. A blend of four single origins, each chosen for the role it plays in the cup. Rich chocolate, smooth caramel, and a subtle brightness that works as espresso, drip, or anything in between.\nBought separately these are $57. Together they are $42, and every Trio ships free.\nBecause the Trio is already $15 off, discount codes do not apply to it. Codes still work on everything else in the same order.\nWant just one instead? Use code FRESHCROP20 for 20% off a bag of Honduras.\nPick ground or whole bean for all three.",
   "tastingNotes": "Honduras: sweet and tart with a soft berry tone, mild nuttiness, and a bright finish.\nEthiopia Yirgacheffe: delicate and aromatic with bright florals, lively citrus, and a natural honey sweetness that lingers.\nEspresso: milk chocolate and roasted nut with warm caramel sweetness and a soft brightness that keeps it balanced.",
   "originStory": "Three coffees that have almost nothing in common, which is the point.\nThe Honduras comes from the Hacia el Futuro cooperative in Zapote. We have been to that farm, met the farmers, and shaken their hands. In 2021 the cooperative built their own washing station, giving those families control over processing their own coffee for the first time. We pay above premium price for every pound, because we have looked these farmers in the eye and we know what their work is worth.\nThe Ethiopia comes from Yirgacheffe, in the country where Arabica coffee began. Not as a crop somebody introduced, but as a plant that has grown there and been part of daily life for centuries. Most of it is shade grown by smallholders on plots that work more like gardens than farms.\nThe Espresso is four origins built to work as one. Brazil brings the body, Honduras the sweetness, Mexico the smoothness, and Ethiopia lifts it all with a subtle brightness.\nAll three roasted in small batches in Belmond, Iowa, and shipped fresh.",
   "elevation": "Honduras: 1200-1700 MASL\nEthiopia: 1900-2400 MASL\nEspresso blend: 750-2400 MASL across Brazil, Honduras, Mexico and Ethiopia",
   "harvest": "Honduras: December to March. Ethiopia: October to January. Espresso is a year round blend sourced across multiple harvest cycles.",
   "grind": "Honduras and Ethiopia are both washed coffees, picked ripe, depulped the same day, fermented in open air tanks, then dried on patios or raised beds. That washed method is what gives them their clean, bright character.\nEspresso is a blend of washed and natural processed coffees. The natural processed Brazil adds body and sweetness while the washed origins contribute clarity and balance.\nChoose ground or whole bean and all three bags come the same way.",
   "rating": null,
   "ratingCount": null,
   "images": [
    {
     "src": "trio_product_photo.png?v=1785658342",
     "alt": "The Trio: Honduras, Espresso and Ethiopia coffee bags from The Golden Hopper"
    },
    {
     "src": "trio_kitchen.png?v=1785658342",
     "alt": "Three Golden Hopper coffee bags on a kitchen counter in morning light"
    }
   ],
   "options": [
    {
     "name": "Grind",
     "values": [
      "Ground",
      "Whole Bean"
     ]
    }
   ],
   "kind": "coffee",
   "descFrom": "body",
   "sub": null,
   "video": {
    "id": "f413cf1f02ed466abd8a76551f2d6516",
    "r": "HD-720p-3.0Mbps-91737329",
    "poster": "preview_images/f413cf1f02ed466abd8a76551f2d6516.thumbnail.0000000000.jpg?v=1786888784",
    "alt": "How naturally processed coffee is harvested and dried",
    "under": "Processing Method",
    "cap": "Watch how this coffee is dried"
   },
   "members": [
    {
     "handle": "honduras",
     "title": "Honduras",
     "color": "#487DB2",
     "notes": [
      "Sweet & Tart",
      "Nutty",
      "Berry"
     ],
     "roast": "Medium",
     "img": "honduras_product_photo.png?v=1778911228",
     "facts": [
      {
       "k": "Grown at",
       "v": "1,200-1,700 m"
      },
      {
       "k": "Picked",
       "v": "December-March"
      },
      {
       "k": "Process",
       "v": "Washed"
      }
     ]
    },
    {
     "handle": "ethiopia-yirgacheffe",
     "title": "Ethiopia Yirgacheffe",
     "color": "#E08A2B",
     "notes": [
      "Jasmine",
      "Citrus",
      "Honey"
     ],
     "roast": "Medium",
     "img": "ethiopia_product_photo.png?v=1778915524",
     "facts": [
      {
       "k": "Grown at",
       "v": "1,900-2,400 m"
      },
      {
       "k": "Picked",
       "v": "October-January"
      },
      {
       "k": "Process",
       "v": "Washed"
      }
     ]
    },
    {
     "handle": "espresso-blend-copy",
     "title": "Espresso Blend",
     "color": "#946326",
     "notes": [
      "Chocolate",
      "Caramel",
      "Nutty"
     ],
     "roast": "Medium",
     "img": "espresso_product_photo.png?v=1778915384",
     "facts": [
      {
       "k": "Grown at",
       "v": "Four origins"
      },
      {
       "k": "Picked",
       "v": "Year-round"
      },
      {
       "k": "Process",
       "v": "Washed + natural"
      }
     ]
    }
   ]
  },
  {
   "handle": "espresso-bean-chocolates-copy",
   "title": "Espresso Bean Chocolates",
   "kind": "goods",
   "description": "Crunchy, chocolate-covered espresso beans made from freshly roasted coffee for maximum flavor and energy. Each batch is made using our small-batch roasted beans, giving you a bold espresso kick with smooth chocolate.\nPerfect for a quick boost, snacking, or gifting. These aren’t stale store-bought beans, they’re fresh, rich, and shipped fast.\nHigh caffeine snack- real coffee beans inside.",
   "descFrom": "body",
   "images": [
    {
     "src": "b128428f-395c-457c-8978-08ce0dac7985.png?v=1778570595",
     "alt": "Chocolate-covered espresso beans from The Golden Hopper"
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "2.5oz",
      "8oz"
     ]
    }
   ],
   "variants": [
    {
     "id": "59580209266769",
     "opts": {
      "Size": "2.5oz"
     },
     "price": 6.79,
     "available": true
    },
    {
     "id": "59580209299537",
     "opts": {
      "Size": "8oz"
     },
     "price": 13.99,
     "available": true
    }
   ],
   "rating": "5.0",
   "ratingCount": 2,
   "best": false,
   "sub": "chocolate",
   "made": {
    "kicker": "Made in the shop",
    "title": "The same beans we roast for the Espresso Blend.",
    "blurb": "These are not bought in. We take the specialty-grade espresso beans we roast for our own Espresso Blend and coat them here, so what is inside the chocolate is the same coffee we sell by the bag.",
    "stat": [
     [
      "The bean",
      "Specialty grade, roasted here"
     ],
     [
      "Coated",
      "In house, small batch"
     ],
     [
      "Caffeine",
      "Real coffee beans inside"
     ]
    ],
    "items": [],
    "itemsLabel": "",
    "warn": "",
    "link": {
     "handle": "espresso-blend-copy",
     "label": "Buy that coffee by the bag",
     "title": "Espresso Blend"
    }
   },
   "reviews": [
    {
     "t": "My sister bought me a bag of these chocolates as a gift and OH MAN were they good. I took them into the office and they were gone in less than three days. They are so, so good!",
     "n": "Kaylee W."
    },
    {
     "t": "Amazing",
     "n": "Arleen M."
    }
   ],
   "color": "#B09040",
   "sheen": "gold"
  },
  {
   "handle": "good-for-you-granola-healthy-granola-high-fiber-small-batch-fresh-made",
   "title": "Good-For-You Granola",
   "kind": "goods",
   "description": "A healthy, small-batch granola made with simple ingredients and no unnecessary fillers. Packed with fiber and natural energy, this granola is made fresh for better taste and texture, not mass-produced like store brands.\nPerfect for breakfast, yogurt, or a clean snack that actually tastes good. **CONTAINS NUTS**\nIngredients: Organic oats, almonds, walnuts, organic maple syrup, olive oil, flax seed, vanilla extract, cinnamon, salt",
   "descFrom": "body",
   "images": [
    {
     "src": "2e5b2c7f-76aa06_5851e2d9a1af4af9a61ef1d1eed6b9f1_mv2.png?v=1778229921",
     "alt": "Good-For-You Granola - Healthy Granola – High Fiber, Small Batch, Fresh Made image 0"
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "6oz",
      "20oz"
     ]
    }
   ],
   "variants": [
    {
     "id": "59489850589265",
     "opts": {
      "Size": "6oz"
     },
     "price": 5.85,
     "available": true
    },
    {
     "id": "59489850556497",
     "opts": {
      "Size": "20oz"
     },
     "price": 16.85,
     "available": true
    }
   ],
   "rating": null,
   "ratingCount": null,
   "best": false,
   "sub": null,
   "made": {
    "kicker": "Nine ingredients",
    "title": "One sweetener, and oats worth paying for.",
    "blurb": "Most granola leans on cane sugar, syrups and fillers to make oats taste like dessert. This one is sweetened with organic maple syrup and nothing else, so what you taste is the oats, the nuts and the cinnamon.",
    "story": {
     "title": "Why the oats are organic",
     "body": "Oats are one of the crops where it matters. Conventional growers are allowed to spray glyphosate onto the crop shortly before harvest to dry it down evenly and bring the combine in sooner, a practice called pre-harvest desiccation. Because it goes onto the grain itself at the very end, it is not something that washes off in the mill. Certified organic production does not permit it. That is the reason we buy organic oats rather than the cheaper sack."
    },
    "stat": [
     [
      "Sweetened with",
      "Organic maple syrup, only"
     ],
     [
      "The oats",
      "Organic"
     ],
     [
      "Fillers",
      "None"
     ]
    ],
    "items": [
     "Organic oats",
     "Almonds",
     "Walnuts",
     "Organic maple syrup",
     "Olive oil",
     "Flax seed",
     "Vanilla extract",
     "Cinnamon",
     "Salt"
    ],
    "itemsLabel": "Everything in the bag",
    "warn": "Contains nuts"
   }
  },
  {
   "handle": "golden-hopper-tumbler",
   "title": "Golden Hopper Tumbler",
   "kind": "goods",
   "description": "The Golden Hopper insulated tumbler. Keep your coffee hot on the go from our small-batch Iowa roastery. Durable, leak-resistant, built for daily use.",
   "descFrom": "seo",
   "images": [
    {
     "src": "ChatGPT_Image_May_12_2026_02_19_54_AM.png?v=1778570425",
     "alt": "The Golden Hopper insulated coffee tumbler"
    },
    {
     "src": "63337359-7101-4e23-93c3-dd70df03afeb.png?v=1778569888",
     "alt": ""
    }
   ],
   "options": [
    {
     "name": "Color",
     "values": [
      "Blue",
      "Black Iridescent"
     ]
    }
   ],
   "variants": [
    {
     "id": "59504789291089",
     "opts": {
      "Color": "Blue"
     },
     "price": 20.0,
     "available": true
    },
    {
     "id": "59504789323857",
     "opts": {
      "Color": "Black Iridescent"
     },
     "price": 20.0,
     "available": false
    }
   ],
   "rating": null,
   "ratingCount": null,
   "best": false,
   "sub": null,
   "color": "#167997",
   "sheen": "iridescent"
  },
  {
   "handle": "coffee-mug",
   "title": "Coffee Mug",
   "kind": "goods",
   "description": "The Golden Hopper ceramic coffee mug. Start your morning with a cup from our small-batch Iowa roastery. A simple, sturdy everyday mug.",
   "descFrom": "seo",
   "images": [
    {
     "src": "d3b3ccb5-76aa06_4f8d4b3d5a4f4f3abdccdc0c2ef9d946_mv2.png?v=1778229919",
     "alt": "The Golden Hopper ceramic coffee mug"
    }
   ],
   "options": [],
   "variants": [
    {
     "id": "59489852293201",
     "opts": {},
     "price": 6.95,
     "available": true
    }
   ],
   "rating": null,
   "ratingCount": null,
   "best": false,
   "sub": null
  },
  {
   "handle": "t-shirt",
   "title": "T-Shirt",
   "kind": "goods",
   "description": "The Golden Hopper t-shirt. Wear your love for small-batch craft coffee roasted fresh in Belmond, Iowa. Soft, comfortable everyday tee.",
   "descFrom": "seo",
   "images": [
    {
     "src": "000052ca-76aa06_c285f7dd9a4e4b868b007690c8de9fd1_mv2.png?v=1778229920",
     "alt": "The Golden Hopper coffee t-shirt"
    }
   ],
   "options": [
    {
     "name": "Size",
     "values": [
      "Small",
      "Medium",
      "Large",
      "X-Large",
      "2X"
     ]
    }
   ],
   "variants": [
    {
     "id": "59489852719185",
     "opts": {
      "Size": "Small"
     },
     "price": 21.95,
     "available": true
    },
    {
     "id": "59489852751953",
     "opts": {
      "Size": "Medium"
     },
     "price": 21.95,
     "available": true
    },
    {
     "id": "59489852620881",
     "opts": {
      "Size": "Large"
     },
     "price": 21.95,
     "available": true
    },
    {
     "id": "59489852653649",
     "opts": {
      "Size": "X-Large"
     },
     "price": 21.95,
     "available": true
    },
    {
     "id": "59489852686417",
     "opts": {
      "Size": "2X"
     },
     "price": 21.95,
     "available": true
    }
   ],
   "rating": "5.0",
   "ratingCount": 1,
   "best": false,
   "sub": null
  }
 ],
 "shared": {
  "freeShippingAt": 35,
  "badges": [
   "✅ Satisfaction Guarantee",
   "🚚 Free Shipping $35+",
   "⏱ Ships in 3–5 Days"
  ],
  "subscription": {
   "groupName": "Subscribe and save",
   "oneTime": "One-time purchase",
   "footnote": "Auto-renews. Skip or cancel any time from the link in your order confirmation email."
  },
  "roastTitle": "Learn about this roast",
  "wholeBeanOrGround": "For the freshest possible cup, choose whole bean and grind just before brewing. Coffee begins losing its aroma and flavor within minutes of grinding. Buying whole bean and grinding at home preserves everything that makes fresh roasted coffee worth it.\nPre-ground is still far fresher than anything on a grocery store shelf and is a great option if you don't have a grinder yet. Either way you're getting coffee roasted as fresh as possible, not sitting on a shelf for months.",
  "specialRequests": {
   "label": "Special Requests",
   "help": "Need a custom grind size or have a special request? Let us know and we will do our best to accommodate.",
   "max": 150,
   "placeholder": "Want free cold brew bags? Just ask here"
  },
  "reviews": {
   "title": "What people say",
   "note": "Reviews of The Golden Hopper, not of this coffee specifically.",
   "items": [
    {
     "n": "Ashley W.",
     "t": "The beans are fantastic. I live in KC, and I cannot find better beans."
    },
    {
     "n": "Josh H.",
     "t": "Great coffee! Stopped in the morning after a blizzard, and the owner Cain was great. Roasts his coffee on site, had great beans, excellent smoothies, and local treats. Such a great space to stop if you’re nearby."
    },
    {
     "n": "Leslie S.",
     "t": "Best coffee ever! It’s the only coffee we buy!"
    },
    {
     "n": "Mary S.",
     "t": "This is the BEST coffee and chocolates you could ever imagine! Cain puts his heart and soul into every variety of beans he roasts."
    },
    {
     "n": "April G.",
     "t": "Cain and his team will do absolutely everything to make you the perfect drink. I’m such a coffee snob and his is some of the best I’ve ever had."
    },
    {
     "n": "Mary S.",
     "t": "Best coffee ever! I can finally drink my coffee black!"
    }
   ]
  },
  "alsoLike": [
   {
    "handle": "coffee-trio-honduras-ethiopia-espresso",
    "title": "The Trio",
    "blurb": "Honduras, Ethiopia and Espresso. Three 12oz bags.",
    "from": 42.0,
    "img": "trio_product_photo.png?v=1785658342"
   },
   {
    "handle": "espresso-bean-chocolates-copy",
    "title": "Espresso Bean Chocolates",
    "blurb": "Chocolate-covered espresso beans.",
    "from": 6.79,
    "img": "b128428f-395c-457c-8978-08ce0dac7985.png?v=1778570595"
   },
   {
    "handle": "good-for-you-granola-healthy-granola-high-fiber-small-batch-fresh-made",
    "title": "Good-For-You Granola",
    "blurb": "High fibre, small batch, fresh made.",
    "from": 5.85,
    "img": "2e5b2c7f-76aa06_5851e2d9a1af4af9a61ef1d1eed6b9f1_mv2.png?v=1778229921"
   }
  ],
  "alsoTitle": "Goes well with this",
  "linksTitle": "While you're here",
  "next": {
   "lab": {
    "href": "/pages/coffee-lab",
    "kicker": "Coffee Lab",
    "title": "How to brew what we roast",
    "blurb": "The numbers we actually use. Ratios by weight, not by scoop.",
    "cta": "Read the brew guides",
    "rows": [
     [
      "Pour over",
      "1:16"
     ],
     [
      "French press",
      "1:15"
     ],
     [
      "Espresso",
      "1:2"
     ],
     [
      "Cold brew",
      "1:8"
     ]
    ]
   },
   "quiz": {
    "href": "https://magenta-licorice-78ac35.netlify.app/",
    "external": true,
    "kicker": "Can't choose",
    "title": "Find your coffee",
    "step": "Question 1 of 3",
    "q": "How do you like your roast?",
    "options": [
     {
      "e": "🌤",
      "t": "Light & bright",
      "d": "Crisp, fruity, lots of clarity"
     },
     {
      "e": "☕",
      "t": "Smooth & balanced",
      "d": "The everyday sweet spot"
     },
     {
      "e": "🌑",
      "t": "Bold & dark",
      "d": "Deep, rich, full-bodied"
     }
    ],
    "cta": "Answer three and see"
   },
   "arcade": {
    "href": "/pages/arcade",
    "kicker": "The Arcade",
    "title": "Three games, free to play",
    "blurb": "Built in the shop between roasts. They run right here in your browser.",
    "cta": "Insert nothing, it is free",
    "games": [
     [
      "Origins",
      "Climb every origin we roast"
     ],
     [
      "Mug Drop",
      "Drop them, merge them, do not overflow"
     ],
     [
      "Hopper Crossing",
      "Get the bean across Main Street"
     ]
    ]
   }
  },
  "subscriptions": {
   "coffee": {
    "plans": [
     {
      "id": 2003796049,
      "label": "Deliver every 2 weeks, 15% off",
      "off": 15
     },
     {
      "id": 2003828817,
      "label": "Deliver every 4 weeks, 10% off",
      "off": 10
     },
     {
      "id": 2003861585,
      "label": "Deliver every 6 weeks, 5% off",
      "off": 5
     }
    ]
   },
   "chocolate": {
    "plans": [
     {
      "id": 2026111057,
      "label": "Deliver every 2 weeks, 10% off",
      "off": 10
     },
     {
      "id": 2026143825,
      "label": "Deliver every 4 weeks, 10% off",
      "off": 10
     }
    ]
   }
  },
  "trio": {
   "handle": "coffee-trio-honduras-ethiopia-espresso",
   "members": [
    "honduras",
    "ethiopia-yirgacheffe",
    "espresso-blend-copy"
   ],
   "kicker": "This one is in The Trio",
   "title": "Want all three?",
   "line": "Bought separately these are $57. Together they are $42, and every Trio ships free.",
   "note": "Pick ground or whole bean for all three.",
   "cta": "See The Trio",
   "price": 42.0,
   "separate": 57.0
  },
  "altRec": {
   "honduras": "colombia",
   "ethiopia-yirgacheffe": "guatemala",
   "espresso-blend-copy": "brazil"
  },
  "moreKicker": "Not just coffee",
  "moreSub": "Four brew guides, a three-question quiz to find your roast, and three games we built in the shop between roasts."
 },
 "vcdn": "https://cdn.shopify.com/videos/c/vp/"
};
var GH_COFFEE = GH_DATA.products;
var GH_SHARED = GH_DATA.shared;
